import { render } from "./BaseButton.vue?vue&type=template&id=a236a67e"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"
script.render = render

export default script